export const remainTokens = [
    {
        address: "6PvwE3Qf2gm6XKhgiT7BsuVih7KUC6SAGwhz6hsEULC",
        hero: 312000000,
        villain: 215500000
    },
    {
        address: "HBh9p1yNSZLFX1bU8YGFoMp9Fh5ZMCfXjms7qzL7zEoY",
        hero: 1125000000,
        villain: 1100000000
    },
    {
        address: "DRygJdnKLcpXGphsEKzxSH7U9nqdsAZgdgN3sE4NsbNd",
        hero: 2000000,
        villain: 3000000
    },
    {
        address: "D8vdtfd6ZjzGdjmUGdp2YRZqenDZPkJ8kUB7pKRJLCWV",
        hero: 25750000,
        villain: 22750000
    },
    {
        address: "6Nwj5JWNMy827Uzxe8aF7Dhhd6CMu1SEJWfv315gQ5P3",
        hero: 5250000,
        villain: 5250000
    },
    {
        address: "6SYd8tyH71yoQy57PhyrBrveZoSm7Rh4yRwp3LfqAN83",
        hero: 63750000,
        villain: 63750000
    },
    {
        address: "GWHUnWbNodNwRyDYgFnCFW1xLpQ48NciPsGYEXsYnCyE",
        hero: 2500000,
        villain: 2500000
    },
    {
        address: "Cpgxp5AKx6tTgqWsfr2rPZfNq5Jn3APfDA26WZ3KXS16",
        hero: 52500000,
        villain: 40000000
    },
    {
        address: "5AVRhXArbTEF7qHYHDFKETYzwTw42NiYbMhU7mgdfraU",
        hero: 2500000,
        villain: 2500000
    },
    {
        address: "GDj1HKKi4HW4rq9XfVHCEUhMyyQMaHA32QaLKFAi35RP",
        hero: 205700000,
        villain: 137500000
    },
    {
        address: "DGCSmti7PkEiieHhkVPj5Njk3DvHrfUGy9BHC3SKertU",
        hero: 707500000,
        villain: 600000000
    },
    {
        address: "6Q6C9g9yaFej5n4QBy1ZN4yDrffWSNSPSZNk5qp39xqC",
        hero: 7590419,
        villain: 11259581
    },
    {
        address: "6Q6C9g9yaFej5n4QBy1ZN4yDrffWSNSPSZNk5qp39xqC",
        hero: 7590419,
        villain: 11259581
    },
    {
        address: "6Q6C9g9yaFej5n4QBy1ZN4yDrffWSNSPSZNk5qp39xqC",
        hero: 7590419,
        villain: 11259581
    },
    {
        address: "95PG9VqbpWi5ZSmxWAs6tbZ7iKvvP1cb7LABBveT8SAD",
        hero: 10000000,
        villain: 10000000
    },
    {
        address: "2gZStJWP4JZhRzpNDfF1sX4FqprNXB3dRyk3SZZk8WE6",
        hero: 50000,
        villain: 0
    },
    {
        address: "erDDZCxYTaGYVBUnHqzBeWjzq9FPb1KpeXgcj4AoxLP",
        hero: 0,
        villain: 500000
    },
    {
        address: "2G16YwiUnUj86D1LMNHC22LPeHWMbZhQWFEwUq5UEXZp",
        hero: 100000,
        villain: 0
    },
    {
        address: "BrJt6PwSgMGcqogtY9mRpdwCY4CHp2qMqHFPHqXL7x7S",
        hero: 250000,
        villain: 0
    },
    {
        address: "7NAwgbT17uNdB47rs2j9MoBrKWPgYcauhZtKKwSzL2Jf",
        hero: 2650000,
        villain: 3150000
    },
    {
        address: "98t1cMHirD1qvMmYPchkDCq3vDTehezFjxT9Cd1m5DEB",
        hero: 1000000,
        villain: 1000000
    },
    {
        address: "DaP6MRyK9bpCzvEDLFHoHkXrpeWNENXGQ67dAFdmw5g5",
        hero: 100000,
        villain: 150000
    },
    {
        address: "C5s2G5chBfeF1gEjPDL4ZSuae3ZMWyTXgGz8izXLhKni",
        hero: 150000,
        villain: 0
    },
    {
        address: "5NDads3TbRrRQP1US3cRjJ4wktdcSZDmTSQzinHMUvhp",
        hero: 5500000,
        villain: 4500000
    },
    {
        address: "5J8LFvmQvkUae5Cxwz1RBxMVt5PqWs6TrCAZKEcP2whx",
        hero: 112000000,
        villain: 70000000
    },
]
